module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boolean-expression-widget"
  }, [_c('header', [(!_vm.editMode) ? _c('button', {
    staticClass: "edit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.enableEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" edit")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? [_c('button', {
    staticClass: "edit-btn edit-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('button', {
    staticClass: "edit-btn edit-btn-save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('boolean-expression', {
    attrs: {
      "expression": _vm.renderedExpression,
      "editMode": _vm.editMode
    },
    on: {
      "editExpression": _vm.edit,
      "addExpression": _vm.add
    }
  })], 1), _vm._v(" "), (_vm.showModal) ? _c('boolean-expression-modal', {
    attrs: {
      "expression": _vm.editAction == 'edit' ? _vm.editedExpression : null
    },
    on: {
      "close": _vm.closeModal,
      "save": _vm.save
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-377528da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/BooleanExpressionWidget.vue
// module id = 655
// module chunks = 0